module.exports = __webpack_public_path__ + "img/sankaku_61_red.5bdfae9d.png";